/**
 * @generated SignedSource<<2d3c6e7899cd4d34f058645c6d77706a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RequestLinkQuery$variables = {
  token: string;
};
export type RequestLinkQuery$data = {
  readonly oauthLinkActivation: {
    readonly oauthProvider: {
      readonly email: string;
      readonly provider: string;
    };
  } | null | undefined;
};
export type RequestLinkQuery = {
  response: RequestLinkQuery$data;
  variables: RequestLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "OauthLinkActivation",
        "kind": "LinkedField",
        "name": "oauthLinkActivation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OauthProvider",
            "kind": "LinkedField",
            "name": "oauthProvider",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RequestLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "OauthLinkActivation",
        "kind": "LinkedField",
        "name": "oauthLinkActivation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OauthProvider",
            "kind": "LinkedField",
            "name": "oauthProvider",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81f47664868b6c3f537f4f3ccd0c5cb6",
    "id": null,
    "metadata": {},
    "name": "RequestLinkQuery",
    "operationKind": "query",
    "text": "query RequestLinkQuery(\n  $token: String!\n) {\n  oauthLinkActivation(token: $token) {\n    oauthProvider {\n      email\n      provider\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c7cb966e44ba86726d6135a89a105b3";

export default node;
